import { useEffect, useState } from "preact/hooks";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import style from "./style.scss";
import {convertToRoman} from "../../../utils"
import ExamQuestion from '../ExamQuestion'
import {
  getTests,
  selectTest,
  fetchExamQuestion,
  getSelectTest,
  resetTest,
  launchTest,
} from "../../../action"
import { Mixpanel } from "../../../Mixpanel";
import { textIdentifier } from "../../../components/Common/textIdentifier";

const Header = props => {
  return (
    <div className={style['test--header']}>
      <div className={style['header--left']}>
        <div className={style['back--logo']} onClick={() => props.goBackTest()}>
          <svg width="16.961" height="12.966" viewBox="0 0 16.961 12.966"><path style="fill:#4d4d4d;" d="M2.875,19.268l5.231-5.231A1.25,1.25,0,0,1,9.873,15.8L6.785,18.91H18.211a1.25,1.25,0,0,1,0,2.5H6.785L9.873,24.5a1.256,1.256,0,1,1-1.785,1.767L2.875,21.053A1.271,1.271,0,0,1,2.5,20.16,1.2,1.2,0,0,1,2.875,19.268Z" transform="translate(-2.5 -13.675)"/></svg>
        </div>
        <div className={style['test--name']}>{props.selectedTest.name}</div>
      </div>
    </div>
  )
}
const GeneralInstruction = (props) => {
  const {language} = useSelector((state)=>state.userSession.user)
  return (
    <div className={style['general--instructions']}>
      <div className={style['instruction--heading']}>{textIdentifier["general-instructions"][language]}</div>
      {props.instructions.map((instruction, index) => {
        return (
          <div className={style["instruction--details"]}>
            ({convertToRoman(index + 1).toLowerCase()}) {instruction}
          </div>
        )
      })}
      <div className={style['main--instruction']}>
      {textIdentifier["make-sure-to-click-'submit-answer'-for-every-question-Forgetting-to-do-so-will-result-in-the-question-being-marked-as-unanswered"][language]}
      </div>
    </div>
  )
}

const ReviewTest = (props) => {
  const {language} = useSelector((state)=>state.userSession.user)
  const { match } = props
  const { params } = match
  const history = useHistory()
  let {
    selectedClass: paramsSelectedClass,
    testId: paramsSelelectedTest,
  } = params

  const [testInfo, setTestInfo] = useState()
  const [showLiveModal, toggleModal] = useState(false)

  const {
    selectedClass,
    selectedTest,
    testsView,
    examQuestions,
    examQuestionLoader,
    userSession
  } = useSelector((state) => state)
  const dispatch = useDispatch()

  useEffect(() => {
    if (!!selectedTest && selectedTest.id == paramsSelelectedTest) {
      dispatch(fetchExamQuestion(selectedTest.configTypeIds, selectedTest.id, 0))
    }
    else {
      dispatch(getSelectTest(paramsSelectedClass))
    }
    if(!!selectedTest){
      Mixpanel.track("TeacherProduct_ExamReviewed", {
        "ExamID": selectedTest.id,
        "ExamName": selectedTest.name
      });
      Mixpanel.people.set({
        "$email": userSession.user.email,
        "TeacherID": userSession.user.id
      });
    }
  }, [])

  useEffect(() => {
    if(!!testsView[paramsSelectedClass]){
      Object.values(testsView[paramsSelectedClass]).flat().every(testObj => {
        if(testObj.id == paramsSelelectedTest) {
          dispatch(selectTest(testObj))
          return false
        }
        else return true
      })
    }
  }, [testsView])

  useEffect(() => {
    if(!!selectedTest) dispatch(fetchExamQuestion(selectedTest.configTypeIds, selectedTest.id, 0))
  }, [selectedTest])

  const handleFailedQuestion = (questionIndex) => {
    dispatch(fetchExamQuestion(selectedTest.configTypeIds,this.props.studentSelectedData.id,questionIndex))
  }

  const goBackTest = () => {
    dispatch(resetTest())
    history.push(`/${paramsSelectedClass}/tests`)
  }

  const mkLaunchTest = () => {
    dispatch(launchTest(selectedTest.id, paramsSelectedClass))
    dispatch(resetTest())
    Mixpanel.track("TeacherProduct_ExamSettingsModified", {
      "Live?": "Yes",
      "ExamID": selectedTest.id,
      "ExamName": selectedTest.name,
      // To be added later
      // "StartDateSetTo": "",
      // "EndDateSetTo": "",
      // "RollingDate?": "",
      // "DurationInMin": ""
    });
    Mixpanel.people.set({
      "$email": userSession.user.email,
      "TeacherID": userSession.user.id
    });
    history.push(`/${paramsSelectedClass}/tests`)
  }

  return (
    <div className={style['test--review']}>
      {!!selectedTest && (
        <div>
          <Header
            selectedTest={selectedTest}
            goBackTest={goBackTest}
          />
        </div>
      )}
      {/* <div>
        <div className={style["make--live"]} onClick={() => toggleModal(true)}>
          <svg width="29.013" height="21.354" viewBox="0 0 29.013 21.354"><g transform="translate(-2.525 -15.125)"><g transform="translate(2.525 15.125)"><path style="fill:#fff;" d="M78.479,15.515a1.318,1.318,0,0,0-1.864,1.864,11.915,11.915,0,0,1,0,16.838,1.31,1.31,0,0,0,0,1.864,1.325,1.325,0,0,0,.917.4,1.206,1.206,0,0,0,.917-.4A14.562,14.562,0,0,0,78.479,15.515Z" transform="translate(-53.702 -15.125)"/><path style="fill:#fff;" d="M64.179,29.715a1.318,1.318,0,0,0-1.864,1.864,5.745,5.745,0,0,1,0,8.129,1.31,1.31,0,0,0,0,1.864,1.325,1.325,0,0,0,.917.4,1.206,1.206,0,0,0,.917-.4A8.337,8.337,0,0,0,64.179,29.715Z" transform="translate(-43.772 -24.986)"/><path style="fill:#fff;" d="M8.629,17.379a1.318,1.318,0,0,0-1.864-1.864,14.553,14.553,0,0,0,0,20.536,1.325,1.325,0,0,0,.917.4,1.206,1.206,0,0,0,.917-.4,1.31,1.31,0,0,0,0-1.864A11.906,11.906,0,0,1,8.629,17.379Z" transform="translate(-2.525 -15.125)"/><path style="fill:#fff;" d="M26.892,31.579a1.318,1.318,0,0,0-1.864-1.864,8.392,8.392,0,0,0,0,11.857,1.325,1.325,0,0,0,.917.4,1.206,1.206,0,0,0,.917-.4,1.31,1.31,0,0,0,0-1.864A5.8,5.8,0,0,1,26.892,31.579Z" transform="translate(-16.448 -24.986)"/></g><circle style="fill:#fff;" cx="2.231" cy="2.231" r="2.231" transform="translate(14.802 23.552)"/></g></svg>
          <span>Make it live</span>
        </div>
      </div> */}
      {showLiveModal && <div className={style["modal-container"]}>
        <div class={style["modal-section"]}>
          <div className={style["icon-container"]}>
          <svg width="65.93" height="67.359" viewBox="0 0 65.93 67.359"><defs><style>{`.a{fill:#424243;}.b{fill:#3d3d3d;}`}</style></defs><g transform="translate(-650 -243)"><g transform="translate(-180)"><g transform="translate(830 243)"><path style="fill:#424243;" d="M311.223,308.2v11.074a14.305,14.305,0,0,1-14.288,14.288H262.943a14.305,14.305,0,0,1-14.288-14.288V278.809a9.255,9.255,0,0,1,9.245-9.245h36.583v-1.681H257.9a10.939,10.939,0,0,0-10.926,10.926v40.464a15.987,15.987,0,0,0,15.969,15.969h33.992A15.988,15.988,0,0,0,312.9,319.273V308.2Z" transform="translate(-246.974 -267.883)"/><rect style="fill:#424243;" width="1.681" height="7.204" transform="translate(64.249 18.884)"/><rect style="fill:#424243;" width="1.681" height="5.043" transform="translate(64.249 10.959)"/><rect style="fill:#424243;" width="1.681" height="8.465" transform="translate(64.249 28.97)"/></g></g><g transform="translate(661.143 247.158)"><g transform="translate(2.525 15.125)"><path style="fill:#3d3d3d;" d="M79.281,15.653a1.787,1.787,0,1,0-2.527,2.527,16.154,16.154,0,0,1,0,22.828,1.776,1.776,0,0,0,0,2.527A1.8,1.8,0,0,0,78,44.075a1.635,1.635,0,0,0,1.243-.539A19.742,19.742,0,0,0,79.281,15.653Z" transform="translate(-45.69 -15.125)"/><path style="fill:#3d3d3d;" d="M64.981,29.853a1.787,1.787,0,1,0-2.527,2.527,7.789,7.789,0,0,1,0,11.021,1.776,1.776,0,0,0,0,2.527,1.8,1.8,0,0,0,1.243.539,1.635,1.635,0,0,0,1.243-.539A11.3,11.3,0,0,0,64.981,29.853Z" transform="translate(-37.315 -23.442)"/><path style="fill:#3d3d3d;" d="M10.8,18.181a1.787,1.787,0,1,0-2.527-2.527,19.73,19.73,0,0,0,0,27.842,1.8,1.8,0,0,0,1.243.539,1.635,1.635,0,0,0,1.243-.539,1.776,1.776,0,0,0,0-2.527A16.141,16.141,0,0,1,10.8,18.181Z" transform="translate(-2.525 -15.125)"/><path style="fill:#3d3d3d;" d="M28.427,32.381A1.787,1.787,0,1,0,25.9,29.853a11.378,11.378,0,0,0,0,16.075,1.8,1.8,0,0,0,1.243.539,1.635,1.635,0,0,0,1.243-.539,1.776,1.776,0,0,0,0-2.527A7.866,7.866,0,0,1,28.427,32.381Z" transform="translate(-14.268 -23.442)"/></g><circle style="fill:#3d3d3d;" cx="3.024" cy="3.024" r="3.024" transform="translate(19.17 26.55)"/></g></g></svg>
          </div>
          <div className={style["statement"]}>{textIdentifier["are-you-sure-you-want-to-make-this-exam-live-for-students"][language]}</div>
          <div className={style["btn-grp"]}>
            <div className={style["cancel-btn"]} onClick={() => toggleModal(false)}>Cancel{textIdentifier["cancel"][language]}</div>
            <div className={style["confirm"]} onClick={() => mkLaunchTest()}>{textIdentifier["confirm"][language]}</div>
          </div>
        </div>
      </div>}
      {!!selectedTest && !!examQuestions && !!examQuestions[selectedTest.id] && (
        <div className={style["exam--container"]}>
          <div className={style['general--instruction--section']}>
            <GeneralInstruction instructions={selectedTest.instruction} />
          </div>
          {Object.values(examQuestions[selectedTest.id]).map((questionElem, index) => {
            if (Array.isArray(questionElem)) {
              return (
                <div key={index} className={style['exam--question--item']}>
                  {questionElem.map((questionData, subIndex) => {
                    return (
                      <div>
                        <ExamQuestion
                          question={questionData}
                          index={index}
                          choiceIndex={`${index}_${subIndex}`}
                          hideQuestionNumber={subIndex !== 0}
                        />
                        {subIndex !== questionElem.length - 1 && (
                          <div className={style['exam-question-choice']}>Or</div>
                        )}
                      </div>
                    )
                  })}
                </div>
              )
            } else {
              return (
                <div key={index} className={style['exam--question--item']}>
                  <ExamQuestion question={questionElem} index={index} showSolution={false} />
                </div>
              )
            }
          })}
         {examQuestionLoader.length > 0 && examQuestionLoader.map((value, index) => {
            if (!!value && value.status === 0) {
                return (
                <div className={style['loader-container']}>
                    <div className={style['question-heading']}>{textIdentifier["question"][language]} {index + 1}</div>
                    <div className={style['loader']}>{textIdentifier["loading"][language]}...</div>
                </div>
                )
            }
            else if(!!value && value.status === -1) {
              return (
                <div className={style['loader-container']}>
                  <div className={style['question-heading']}>{textIdentifier["question"][language]} {index + 1}</div>
                  <div onClick ={()=>{this.handleFailedQuestion(index)}} className={style['loader']}>{textIdentifier["click-here-to-load-this"][language]}</div>
                </div>
              )
            }
          })}
        </div>
      )}
    </div>
  );
};

export default ReviewTest;
